// const host = "http://t.emc.bitiot.com.cn/v1";
// const host = "http://192.168.20.175:9120/v1";

const host = {
    start:"http://t.emc.bitiot.com.cn/v1",
    test:"http://t.emc.bitiot.com.cn/v1",
    production:"https://emc.bitiot.com.cn/v1",
}
export default host[process.env.VUE_APP_CUSTOM_ENV]